import React from 'react';

const PrivacyPolicy = () => {
    return (
        <div className='bg-[#05003E] '>

            <div className="max-w-4xl mx-auto p-6 text-[#FFFFFF] font-playfair">
                <h1 className="text-3xl font-semibold mb-6 text-[#FFFFFF]">Privacy Policy</h1>

                <p className="mb-4">
                    At <strong>IndUS Tech</strong>, we are committed to protecting your privacy. This Privacy Policy outlines how we collect, use, and safeguard your personal information when you interact with our website or services.
                </p>

                <h2 className="text-2xl font-semibold mt-8 mb-4">1. Information We Collect</h2>
                <p className="mb-4">We may collect the following types of personal data:</p>
                <ul className="list-disc pl-6 mb-4">
                    <li>Your name and email address (e.g., when you fill out a form)</li>
                    <li>Company and designation details (if applicable)</li>
                    <li>IP address and browser data for analytics</li>
                </ul>

                <h2 className="text-2xl font-semibold mt-8 mb-4">2. How We Use Your Information</h2>
                <ul className="list-disc pl-6 mb-4">
                    <li>To respond to your inquiries and support requests</li>
                    <li>To send newsletters or updates if you’ve subscribed</li>
                    <li>To improve our services and user experience</li>
                </ul>

                <h2 className="text-2xl font-semibold mt-8 mb-4">3. Cookies</h2>
                <p className="mb-4">
                    We may use cookies to enhance your browsing experience. You can control or delete cookies through your browser settings.
                </p>

                <h2 className="text-2xl font-semibold mt-8 mb-4">4. Data Sharing</h2>
                <p className="mb-4">
                    We do not sell, rent, or trade your personal information. We may share your data with trusted third-party services for analytics or email distribution, only under strict confidentiality.
                </p>

                <h2 className="text-2xl font-semibold mt-8 mb-4">5. Security</h2>
                <p className="mb-4">
                    We implement industry-standard security measures to protect your information from unauthorized access, alteration, or disclosure.
                </p>

                <h2 className="text-2xl font-semibold mt-8 mb-4">6. Your Rights</h2>
                <p className="mb-4">
                    You have the right to access, update, or delete your personal information. If you'd like to do so, please contact us at <a href="mailto:info@industechcouncil.org" className="text-[#FFFFFF] underline">info@industechcouncil.org</a>.
                </p>

                <h2 className="text-2xl font-semibold mt-8 mb-4">7. Changes to this Policy</h2>
                <p className="mb-4">
                    We may update this Privacy Policy from time to time. Changes will be posted on this page with a revised date.
                </p>

                <p className="mt-8 text-sm text-[#FFFFFF]">Last updated: July 25, 2025</p>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
